'use client'

import { Button, Image } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { TAX_RULES_UNIVERSAL_URL } from '../../constants'

const TaxRulesSection = () => {
  const translate = useTranslate('dac7-2024.tax-rules')
  const { track } = useTracking()
  const asset = useAsset('/assets/landing-pages/dac7')

  const handleOnCtaClick = () => {
    track(
      clickEvent({
        screen: 'dac7',
        target: 'cta_redirect',
        targetDetails: `taxrules_section__${TAX_RULES_UNIVERSAL_URL}`,
      }),
    )
  }

  const imageSrc = asset('Illustration-1.png')
  const imageSrc2x = asset('Illustration-1@2x.png')
  const imageSrc3x = asset('Illustration-1@3x.png')
  const imageSrcSet = `${imageSrc} 1x, ${imageSrc2x} 2x, ${imageSrc3x} 3x`

  const imageSrcMobile = asset('Illustration-1-mobile.png')
  const imageSrc2xMobile = asset('Illustration-1-mobile@2x.png')
  const imageSrc3xMobile = asset('Illustration-1-mobile@3x.png')
  const imageSrcSetMobile = `${imageSrcMobile} 1x, ${imageSrc2xMobile} 2x, ${imageSrc3xMobile} 3x`

  return (
    <section className="dac7__taxrules" data-testid="taxrules-section">
      <div className="dac7__taxrules-inner">
        <div>
          <h2 className="dac7__taxrules-title">{translate('title')}</h2>
          <div className="dac7__taxrules-image u-mobiles-only">
            <Image
              src={imageSrcMobile}
              srcset={imageSrcSetMobile}
              scaling={Image.Scaling.Cover}
              loading="lazy"
            />
          </div>
          <p className="dac7__taxrules-description">{translate('description')}</p>
          <div className="dac7__taxrules-cta">
            <Button
              styling={Button.Styling.Filled}
              text={<span className="dac7__taxrules-cta-text">{translate('action')}</span>}
              url={TAX_RULES_UNIVERSAL_URL}
              onClick={handleOnCtaClick}
              testId="taxrules-cta"
              inverse
            />
          </div>
        </div>
        <div className="dac7__taxrules-image u-desktops-only">
          <Image src={imageSrc} srcset={imageSrcSet} scaling={Image.Scaling.Cover} loading="lazy" />
        </div>
      </div>
    </section>
  )
}

export default TaxRulesSection
